import { render } from "./HeaderPage.vue?vue&type=template&id=9530d7e8&scoped=true&ts=true"
import script from "./HeaderPage.vue?vue&type=script&lang=ts"
export * from "./HeaderPage.vue?vue&type=script&lang=ts"

import "./HeaderPage.vue?vue&type=style&index=0&id=9530d7e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9530d7e8"]])

export default __exports__